/**
 * Prominent banner with back button for onboarding step pages
 * Provides clear navigation back to the steps grid
 */

import { ActionIcon, Box, Group, Text } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";

interface OnboardingStepBannerProps {
  onBack: () => void;
  title?: string;
}

/**
 * Dedicated banner component for step navigation
 * Shows a prominent back button with optional title
 */
const OnboardingStepBanner = ({
  onBack,
  title = "Back to Steps",
}: OnboardingStepBannerProps) => {
  return (
    <Box
      style={{
        borderBottom: "1px solid #e9ecef",
        marginBottom: "24px",
        paddingBottom: "16px",
      }}
    >
      <Group gap="sm" wrap="nowrap">
        <ActionIcon
          variant="light"
          size="lg"
          color="blue"
          onClick={onBack}
          style={{
            borderRadius: "8px",
          }}
        >
          <IconArrowLeft size={20} stroke={2.5} />
        </ActionIcon>
        <Text size="md" fw={500} c="dimmed">
          {title}
        </Text>
      </Group>
    </Box>
  );
};

export default OnboardingStepBanner;
